import React from "react";
import _ from "lodash";

import Checkbox from "components/common/Checkbox";

const titleClass = "block text-gray-800 text-sm font-bold"; //"font-semibold";
const subTitleClass = "text-gray-600 text-xs font-semibold ml-1";

class RegisteredInventoryConfig extends React.Component {
  constructor(props) {
    super(props);

    this.handleChanged = this.handleChanged.bind(this);
  }

  handleChanged({ key, value }) {
    const { schema, riConfig } = this.props;

    let newConfig = { ...riConfig, [key]: value };

    if (
      key === "enable_optimization" &&
      value === true &&
      _.isNil(newConfig.time_granularity)
    ) {
      newConfig.time_granularity = 6;
    }

    if (key === "enable_optimization" && value === false) {
      newConfig = { enable_optimization: false };
    }

    // riConfig
    this.props.handleRIChanged({ key: schema.key, config: newConfig });
  }

  render() {
    const { schema, integration, riConfig } = this.props;

    let configInputElement = "";
    const isDisabled = riConfig["enable_optimization"] === false;

    if (schema.valueType === "boolean") {
      configInputElement = (
        <div className="flex gap-4">
          <label
            htmlFor={`${integration}_${schema.key}_radio_true`}
            className="cursor-pointer"
          >
            <input
              id={`${integration}_${schema.key}_radio_true`}
              type="radio"
              value="true"
              checked={riConfig[schema.key] === true}
              onChange={() =>
                this.handleChanged({
                  key: schema.key,
                  value: true,
                })
              }
              required
            />{" "}
            True
          </label>

          <label
            htmlFor={`${integration}_${schema.key}_radio_false`}
            className="cursor-pointer"
          >
            <input
              id={`${integration}_${schema.key}_radio_false`}
              type="radio"
              value="false"
              checked={riConfig[schema.key] === false}
              onChange={() =>
                this.handleChanged({
                  key: schema.key,
                  value: false,
                })
              }
              required
            />{" "}
            False
          </label>
        </div>
      );
    } else if (schema.valueType === "integer_enum") {
      configInputElement = (
        <div className="flex gap-4">
          {schema.enum.map((option) => {
            return (
              <label
                key={option}
                htmlFor={`${integration}_${schema.key}_radio_${option}`}
                className={`flex items-center ${
                  isDisabled ? "opacity-50" : "cursor-pointer"
                }`}
              >
                <input
                  id={`${integration}_${schema.key}_radio_${option}`}
                  type="radio"
                  value="true"
                  className={`${
                    isDisabled ? "cursor-not-allowed opacity-50" : ""
                  }`}
                  disabled={isDisabled}
                  checked={riConfig[schema.key] === option}
                  onChange={() =>
                    this.handleChanged({
                      key: schema.key,
                      value: option,
                    })
                  }
                />{" "}
                {option}
              </label>
            );
          })}
        </div>
      );
    } else if (schema.valueType === "array") {
      configInputElement = (
        <div className="flex gap-4">
          {schema.arrayOptions.map((option) => {
            const isChecked = _.indexOf(riConfig[schema.key], option) !== -1;
            return (
              <div key={option}>
                <label
                  className={`flex items-center ${
                    isDisabled ? "opacity-50" : "cursor-pointer"
                  }`}
                >
                  <Checkbox
                    isChecked={isChecked}
                    isDisabled={isDisabled}
                    onChange={() => {
                      const origin = riConfig[schema.key] || [];
                      const value = isChecked
                        ? origin.filter((d) => d !== option)
                        : [...origin, option];

                      return this.handleChanged({
                        key: schema.key,
                        value,
                      });
                    }}
                  ></Checkbox>
                  <span className="ml-1 align-middle text-sm font-medium text-gray-800 hover:text-gray-700">
                    {option}
                  </span>
                </label>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div>
        <div className={titleClass}>
          {schema.title}
          {schema.subTitle && (
            <span className={subTitleClass}>({schema.subTitle})</span>
          )}
        </div>
        <div>{configInputElement}</div>
      </div>
    );
  }
}

export default RegisteredInventoryConfig;
